const rs_kakao = {
  dev: {
    env: "dev",
    base_url: "https://fce0ihuule.execute-api.us-east-1.amazonaws.com/v0",
    sigilUrl: "https://qa-sigil.qashopltk.com",
    legacyHomePage: "https://creator.qashopltk.com",
    accessTokenCookie: "qa_sigil_access_token",
    idTokenCookie: "qa_sigil_id_token",
    auth0: {
      audience: "https://creator-api-gateway.qashopltk.com/v1",
      clientId: "4seva2GL8OhiWvEz1ilBhSqYhHCwuVDB",
      domain: "qa-rs-influencer.us.auth0.com",
      redirectUri: `${window.location.origin}/login/callback`,
    },
    debug: true,
  },

  qa: {
    env: "qa",
    base_url: "https://fce0ihuule.execute-api.us-east-1.amazonaws.com/v0",
    sigilUrl: "https://qa-sigil.qashopltk.com",
    legacyHomePage: "https://creator.qashopltk.com",
    accessTokenCookie: "qa_sigil_access_token",
    idTokenCookie: "qa_sigil_id_token",
    auth0: {
      audience: "https://creator-api-gateway.qashopltk.com/v1",
      clientId: "4seva2GL8OhiWvEz1ilBhSqYhHCwuVDB",
      domain: "qa-rs-influencer.us.auth0.com",
      redirectUri: `${window.location.origin}/login/callback`,
    },
    debug: false,
  },

  prod: {
    env: "prod",
    base_url: "https://fc9es8oah6.execute-api.us-east-1.amazonaws.com/v0",
    debug: false,
    sigilUrl: "https://auth-creator.shopltk.com",
    legacyHomePage: "https://creator.shopltk.com",
    accessTokenCookie: "sigil_access_token",
    idTokenCookie: "sigil_id_token",
    auth0: {
      audience: "https://creator-api-gateway.shopltk.com/v1",
      clientId: "tk8NpZfw5VLwAbqPF49l3PgQLe7E6sJ8",
      domain: "prod-rs-influencer.us.auth0.com",
      redirectUri: `${window.location.origin}/login/callback`,
    },
  },
};

export default rs_kakao;
